import { Alert, AlertIcon, AlertTitle } from "@/components/elements/Alert";

import { useConnectionCDCFeaturesContext } from "./ConnectionFeaturesContext";

/**
 * The prerequisite is a property of the connection, not of one table — so this belongs above the
 * list, once, rather than on each row. Without it an unmet prerequisite only shows up as a missing
 * per-table CDC toggle, which reads as "Weld cannot do this" instead of "your server needs a change".
 */
export const CdcUnavailableNotice = () => {
  const { changeDataCaptureEnabled, unsupportedReason } =
    useConnectionCDCFeaturesContext();

  if (changeDataCaptureEnabled || !unsupportedReason) {
    return null;
  }

  return (
    <Alert status="warning" className="mb-4 items-start">
      <AlertIcon />
      <div>
        <AlertTitle>Change Data Capture is not available yet</AlertTitle>
        <div>{unsupportedReason}</div>
      </div>
    </Alert>
  );
};
